import { jsx } from 'react/jsx-runtime';
import classNames from '../../../node_modules/.pnpm/classnames@2.5.1/node_modules/classnames/index.js';
import style from './Badge.module.css.js';

const Badge = ({ children, variant = "primary", }) => {
    return jsx("div", { className: classNames(style.badge, style[variant]), children: children });
};

export { Badge };
//# sourceMappingURL=Badge.js.map
